import React from 'react'
import { getMostRecentUnexecutedSearches, getSearches } from 'services/FionaAPI/Search/searchHelpers'
import { SearchWithExtras } from 'generated/api'
import { DashboardSummaryCard } from 'experiences/search/components/SearchSummaryCard/DashboardSummaryCard'
import { createDataWrapper } from 'components/patterns/suspense/internals/DataWrapper'
import { DashboardGroup, DashboardItem } from './types'
import { ID, Nullable } from 'lib'

/**
 * This one is ridiculous because it has a fallback chain that involves both another item, and another request.
 * e.g. For the first item's content, we want to show pending IFF there is a pending search, otherwise show the first completed search
 * If there is no executed searches, then it will throw the loading  boundary will inject the fallback.
 *
 * This obviously needs more than what time I was able to spend on it
 *
 * I need to memo this so we dont rerender cause articles
 *
 */
export const getDashboardSearchesGroup = (): DashboardGroup => {
	const pendingSearch = getMostRecentUnexecutedSearches()
	const completedSearches = getSearches(2)

	const firstCardSuspender = async (): Promise<Nullable<SearchWithExtras>> => {
		const pending = await pendingSearch
		if (pending) return pending
		const completed = await completedSearches
		if (completed[0]) return completed[0]
		return null
	}
	const pendingDataWrapper = createDataWrapper(firstCardSuspender)
	const pendingSearchItem: DashboardItem = {
		loadingContent: <DashboardSummaryCard />,
		Content: () => <DashboardSummaryCard search={pendingDataWrapper.read()} />,
		key: ID('pending'),
		wrapperStyle: 'none'
	}

	const secondCardSuspender = async (): Promise<Nullable<SearchWithExtras>> => {
		const completed = await completedSearches
		if (completed[0]) {
			const pendingSearch = await pendingDataWrapper.onComplete()
			const unshownSearch = completed.find(search => search.id != pendingSearch.id)
			if (unshownSearch) return unshownSearch
		}
		return null
	}
	const secondDataWrapper = createDataWrapper(secondCardSuspender)
	const secondSearchItem: DashboardItem = {
		loadingContent: <DashboardSummaryCard />,
		Content: () => <DashboardSummaryCard search={secondDataWrapper.read()} />,
		key: ID('second'),
		wrapperStyle: 'none'
	}

	return { key: 'searches', items: [pendingSearchItem, secondSearchItem] }
}
